import { render } from "./Dashboard.vue?vue&type=template&id=2b5ee5a0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=2b5ee5a0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b5ee5a0"

export default script